<div class="card-body">
    <div class="form-group">
        <label for="year" class="form-label">Año</label>
        <select class="form-select" name="year" id="year" (change)="updateChart()" [(ngModel)]="year">
            <option *ngFor="let y of years" [ngValue]="y">{{y}}</option>
        </select>
    </div>
	<div class="row">
		<div [ngClass]="show?'col-lg-6':'col'">
			<div id="accounting-general-balance"></div>
		</div>
		<div class="col-lg-6" [hidden]="!show">
			<div id="accounting-general-detail"></div>
		</div>
	</div>
</div>